export default __webpack_public_path__ + "static/media/viper-icon.a5847429.svg";